const BUTTON_SIZES = {
  FUNCTIONAL: 'func',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
};

const BUTTON_COLOR_TYPES = {
  ERROR: 'error',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
};

const BUTTON_TYPES = {
  ICON: 'icon',
  LINK: 'link',
  NORMAL: 'normal',
  OUTLINED: 'outlined',
  TEXT: 'text',
};

export default {
  name: 'WButton',
  props: {
    colorType: {
      default: BUTTON_COLOR_TYPES.PRIMARY,
      type: String,
      validator: (val) => Object.values(BUTTON_COLOR_TYPES).includes(val),
    },
    fontWeightClass: {
      default: 'font-medium',
      type: String,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    size: {
      default: BUTTON_SIZES.MEDIUM,
      type: String,
      validator: (val) => Object.values(BUTTON_SIZES).includes(val),
    },
    type: {
      default: BUTTON_TYPES.NORMAL,
      type: String,
      validator: (val) => Object.values(BUTTON_TYPES).includes(val),
    },
  },
  computed: {
    buttonClasses() {
      return `${this.buttonTypeClasses} ${this.buttonSizeClasses} ${this.fontWeightClass} rounded`;
    },
    buttonSizeClasses() {
      if (this.type === BUTTON_TYPES.ICON) {
        return 'p-1';
      }
      if (this.type === BUTTON_TYPES.TEXT) {
        return '';
      }

      switch (this.size) {
        case BUTTON_SIZES.FUNCTIONAL:
          return 'px-2 py-2 text-xs';

        case BUTTON_SIZES.SMALL:
          return 'px-4 py-[9px] text-sm';

        case BUTTON_SIZES.LARGE:
          return 'px-6 py-4 text-base';

        case BUTTON_SIZES.MEDIUM:
        default:
          return 'px-4 py-[10px] text-base';
      }
    },
    buttonTypeClasses() {
      switch (this.colorType) {
        case BUTTON_COLOR_TYPES.ERROR:
          return this.errorClasses;

        case BUTTON_COLOR_TYPES.SECONDARY:
          return this.secondaryClasses;

        case BUTTON_COLOR_TYPES.PRIMARY:
        default:
          return `${this.primaryClasses}`;
      }
    },
    errorClasses() {
      switch (this.type) {
        case BUTTON_TYPES.LINK:
          return 'w-button__error w-button__error--link';

        case BUTTON_TYPES.OUTLINED:
          return 'w-button__error w-button__error--outlined';

        case BUTTON_TYPES.NORMAL:
        default:
          return 'w-button__error w-button__error--normal';
      }
    },
    primaryClasses() {
      switch (this.type) {
        case BUTTON_TYPES.ICON:
          return 'w-button__primary--icon';

        case BUTTON_TYPES.LINK:
          return 'w-button__primary w-button__primary--link';

        case BUTTON_TYPES.OUTLINED:
          return 'w-button__primary w-button__primary--outlined';

        case BUTTON_TYPES.TEXT:
          return 'w-button__primary w-button__primary--text';

        case BUTTON_TYPES.NORMAL:
        default:
          return 'w-button__primary w-button__primary--normal';
      }
    },
    secondaryClasses() {
      switch (this.type) {
        case BUTTON_TYPES.LINK:
          return 'w-button__secondary w-button__secondary--link';

        case BUTTON_TYPES.OUTLINED:
          return 'w-button__secondary w-button__secondary--outlined';

        case BUTTON_TYPES.TEXT:
          return 'w-button__secondary w-button__secondary--text';

        case BUTTON_TYPES.NORMAL:
        default:
          return 'w-button__secondary w-button__secondary--normal';
      }
    },
  },
};
